import _typeof from "../../helpers/esm/typeof";
import assertThisInitialized from "./assertThisInitialized";
export default function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return assertThisInitialized(self);
}


//////////////////
// WEBPACK FOOTER
// ./~/@babel/runtime/helpers/esm/possibleConstructorReturn.js
// module id = 104
// module chunks = 0